import React from "react";
import {
  Flex,
  Grid,
  Heading,
  Icon,
  Image,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";

import FooterNav from "./FooterNav";
import {
  FaXTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa6";
import { useColorModeValue } from "../ui/color-mode";

const Footer = () => {
  const bg = useColorModeValue("#b8fff7", "#090110");

  const quickLinks = [
    { text: "About", url: "/about" },
    { text: "Contact", url: "/contact" },
    { text: "FAQs", url: "/contact#faq" },
  ];

  const popularServices = [
    { text: "ITR Filing", url: "/itr-filing" },
    { text: "GST Filing", url: "/gst-filing" },
    { text: "Business Registration", url: "/business-registration" },
    { text: "Expert CA Assistance", url: "/expert-assistance" },
  ];

  const socialmedias = [
    {
      icon: FaInstagram,
      url: "https://www.instagram.com/360fintax/",
    },
    {
      icon: FaFacebookF,
      url: "#",
    },
    {
      icon: FaXTwitter,
      url: "#",
    },
    {
      icon: FaLinkedinIn,
      url: "https://www.linkedin.com/company/360fintax/",
    },
  ];

  return (
    <>
      <Stack bgColor={bg}>
        <Grid
          templateColumns={{ base: "repeat( 1fr)", md: "repeat(4, 1fr )" }}
          justifyItems="center"
          justifyContent="space-between"
          gap={{ base: "14", md: "0" }}
          px={{ base: "10", md: "10", lg: "20" }}
          py={10}
        >
          {/* Col 1 */}
          <Stack
            gap={2}
            direction="column"
            textAlign={{ base: "center", md: "left" }}
            alignItems={{ base: "center", md: "none" }}
          >
            <Image
              objectFit="contain"
              src="../assets/logo.png"
              alt="logo"
              w={{ base: "250px", md: "300px" }}
            />
            <Text
              color="gray.500"
              fontSize={{ base: "xs", md: "xs", lg: "sm" }}
            >
              Simplifying Taxes and Compliance for Individuals and Businesses.
            </Text>
          </Stack>

          {/* Col 2 */}
          <FooterNav heading="Company" items={quickLinks} />

          {/* Col 3 */}
          <FooterNav heading="Services" items={popularServices} />

          {/* Mobile Accordion
          <AccordionRoot
            collapsible
            color="black"
            display={{ base: "block", md: "none" }}
          >
            <AccordionItem borderColor="gray" value="a">
              <AccordionItemTrigger>POPULAR SERVICES</AccordionItemTrigger>
              <AccordionItemContent>
                <FooterNav items={popularServices} />
              </AccordionItemContent>
            </AccordionItem>
            <AccordionItem borderColor="gray" value="b">
              <AccordionItemTrigger>QUICK LINKS</AccordionItemTrigger>
              <AccordionItemContent>
                <FooterNav items={quickLinks} />
              </AccordionItemContent>
            </AccordionItem>
          </AccordionRoot> */}

          {/* Col 4 */}
          <Stack gap={4} textAlign={{ base: "center", md: "left" }}>
            <Heading
              as="h6"
              size={{ base: "lg", md: "xs", lg: "md" }}
              fontWeight="semibold"
            >
              Contact us
            </Heading>

            <Text
              color="gray.500"
              fontWeight="semibold"
              fontSize={{ base: "md", md: "xs", lg: "sm" }}
            >
              Phone: +919757476672
            </Text>
            <Text
              color="gray.500"
              fontWeight="semibold"
              fontSize={{ base: "md", md: "xs", lg: "sm" }}
            >
              Email: connect.360fintax@gmail.com
            </Text>

            {/* Social Icons */}
            <Stack gap={5} alignItems={{ base: "center", md: "start" }}>
              <Heading
                as="h6"
                size={{ base: "lg", md: "xs", lg: "md" }}
                fontWeight="semibold"
              >
                Socials
              </Heading>
              <Flex gap={5}>
                {socialmedias.map((social) => (
                  <Link href={social.url}>
                    <Icon
                      color="#008080"
                      _hover={{ color: "#66b2b2", transform: "scale(1.3)" }}
                      transition="transform 0.2s ease-in-out"
                      boxSize={5}
                    >
                      <social.icon />
                    </Icon>
                  </Link>
                ))}
              </Flex>
            </Stack>
          </Stack>
        </Grid>

        <Text
          color="gray"
          fontSize={{ base: "xs", md: "sm" }}
          py={5}
          textAlign="center"
        >
          Copyright © {new Date().getFullYear()} , 360fintax. All Rights
          Reserved.
        </Text>
      </Stack>
    </>
  );
};

export default Footer;
